import { render, staticRenderFns } from "./DriverNotificationsSection.vue?vue&type=template&id=34e704d0&scoped=true"
import script from "./DriverNotificationsSection.vue?vue&type=script&lang=js"
export * from "./DriverNotificationsSection.vue?vue&type=script&lang=js"
import style0 from "./DriverNotificationsSection.vue?vue&type=style&index=0&id=34e704d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e704d0",
  null
  
)

export default component.exports